import _classCallCheck from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { __rest } from "tslib";
import * as React from 'react';
import { KEY_CODES } from '../../helpers/constants';
import { css } from '@patternfly/react-styles';
import styles from '@patternfly/react-styles/css/components/Wizard/wizard';
import { Modal, ModalVariant } from '../Modal';
import { WizardFooterInternal } from './WizardFooterInternal';
import { WizardToggle } from './WizardToggle';
import { WizardNav } from './WizardNav';
import { WizardNavItem } from './WizardNavItem';
import { WizardContextProvider } from './WizardContext';
import { WizardHeader } from './WizardHeader';
export var Wizard =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Wizard, _React$Component);

  function Wizard(props) {
    var _this;

    _classCallCheck(this, Wizard);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Wizard).call(this, props));

    _this.handleKeyClicks = function (event) {
      if (event.keyCode === KEY_CODES.ESCAPE_KEY) {
        if (_this.state.isNavOpen) {
          _this.setState({
            isNavOpen: !_this.state.isNavOpen
          });
        } else if (_this.props.isOpen) {
          _this.props.onClose();
        }
      }
    };

    _this.onNext = function () {
      var _this$props = _this.props,
          onNext = _this$props.onNext,
          onClose = _this$props.onClose,
          onSave = _this$props.onSave;
      var currentStep = _this.state.currentStep;

      var flattenedSteps = _this.getFlattenedSteps();

      var maxSteps = flattenedSteps.length;

      if (currentStep >= maxSteps) {
        // Hit the save button at the end of the wizard
        if (onSave) {
          return onSave();
        }

        return onClose();
      } else {
        var newStep = currentStep + 1;

        _this.setState({
          currentStep: newStep
        });

        var _flattenedSteps = flattenedSteps[currentStep - 1],
            prevId = _flattenedSteps.id,
            prevName = _flattenedSteps.name;
        var _flattenedSteps2 = flattenedSteps[newStep - 1],
            id = _flattenedSteps2.id,
            name = _flattenedSteps2.name;
        return onNext && onNext({
          id: id,
          name: name
        }, {
          prevId: prevId,
          prevName: prevName
        });
      }
    };

    _this.onBack = function () {
      var onBack = _this.props.onBack;
      var currentStep = _this.state.currentStep;

      var flattenedSteps = _this.getFlattenedSteps();

      if (flattenedSteps.length < currentStep) {
        // Previous step was removed, just update the currentStep state
        var adjustedStep = flattenedSteps.length;

        _this.setState({
          currentStep: adjustedStep
        });
      } else {
        var newStep = currentStep - 1 <= 0 ? 0 : currentStep - 1;

        _this.setState({
          currentStep: newStep
        });

        var _flattenedSteps$newSt = flattenedSteps[newStep],
            prevId = _flattenedSteps$newSt.id,
            prevName = _flattenedSteps$newSt.name;
        var _flattenedSteps3 = flattenedSteps[newStep - 1],
            id = _flattenedSteps3.id,
            name = _flattenedSteps3.name;
        return onBack && onBack({
          id: id,
          name: name
        }, {
          prevId: prevId,
          prevName: prevName
        });
      }
    };

    _this.goToStep = function (step) {
      var onGoToStep = _this.props.onGoToStep;
      var currentStep = _this.state.currentStep;

      var flattenedSteps = _this.getFlattenedSteps();

      var maxSteps = flattenedSteps.length;

      if (step < 1) {
        step = 1;
      } else if (step > maxSteps) {
        step = maxSteps;
      }

      _this.setState({
        currentStep: step,
        isNavOpen: false
      });

      var _flattenedSteps4 = flattenedSteps[currentStep - 1],
          prevId = _flattenedSteps4.id,
          prevName = _flattenedSteps4.name;
      var _flattenedSteps5 = flattenedSteps[step - 1],
          id = _flattenedSteps5.id,
          name = _flattenedSteps5.name;
      return onGoToStep && onGoToStep({
        id: id,
        name: name
      }, {
        prevId: prevId,
        prevName: prevName
      });
    };

    _this.goToStepById = function (stepId) {
      var flattenedSteps = _this.getFlattenedSteps();

      var step;

      for (var i = 0; i < flattenedSteps.length; i++) {
        if (flattenedSteps[i].id === stepId) {
          step = i + 1;
          break;
        }
      }

      if (step) {
        _this.setState({
          currentStep: step
        });
      }
    };

    _this.goToStepByName = function (stepName) {
      var flattenedSteps = _this.getFlattenedSteps();

      var step;

      for (var i = 0; i < flattenedSteps.length; i++) {
        if (flattenedSteps[i].name === stepName) {
          step = i + 1;
          break;
        }
      }

      if (step) {
        _this.setState({
          currentStep: step
        });
      }
    };

    _this.getFlattenedSteps = function () {
      var steps = _this.props.steps;
      var flattenedSteps = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = steps[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var step = _step.value;

          if (step.steps) {
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = step.steps[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var childStep = _step2.value;
                flattenedSteps.push(childStep);
              }
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                  _iterator2.return();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }
          } else {
            flattenedSteps.push(step);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return flattenedSteps;
    };

    _this.getFlattenedStepsIndex = function (flattenedSteps, stepName) {
      for (var i = 0; i < flattenedSteps.length; i++) {
        if (flattenedSteps[i].name === stepName) {
          return i + 1;
        }
      }

      return 0;
    };

    _this.initSteps = function (steps) {
      // Set default Step values
      for (var i = 0; i < steps.length; i++) {
        if (steps[i].steps) {
          for (var j = 0; j < steps[i].steps.length; j++) {
            steps[i].steps[j] = Object.assign({
              canJumpTo: true
            }, steps[i].steps[j]);
          }
        }

        steps[i] = Object.assign({
          canJumpTo: true
        }, steps[i]);
      }

      return steps;
    };

    _this.getElement = function (appendTo) {
      if (typeof appendTo === 'function') {
        return appendTo();
      }

      return appendTo || document.body;
    };

    var newId = Wizard.currentId++;
    _this.titleId = props.titleId || "pf-wizard-title-".concat(newId);
    _this.descriptionId = props.descriptionId || "pf-wizard-description-".concat(newId);
    _this.state = {
      currentStep: _this.props.startAtStep && Number.isInteger(_this.props.startAtStep) ? _this.props.startAtStep : 1,
      isNavOpen: false
    };
    return _this;
  }

  _createClass(Wizard, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var target = typeof document !== 'undefined' ? document.body : null;

      if (target) {
        target.addEventListener('keydown', this.handleKeyClicks, false);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var target = typeof document !== 'undefined' && document.body || null;

      if (target) {
        target.removeEventListener('keydown', this.handleKeyClicks, false);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _a = this.props,
          width = _a.width,
          height = _a.height,
          title = _a.title,
          description = _a.description,
          onClose = _a.onClose,
          onSave = _a.onSave,
          onBack = _a.onBack,
          onNext = _a.onNext,
          onGoToStep = _a.onGoToStep,
          className = _a.className,
          steps = _a.steps,
          startAtStep = _a.startAtStep,
          _a$nextButtonText = _a.nextButtonText,
          nextButtonText = _a$nextButtonText === void 0 ? 'Next' : _a$nextButtonText,
          _a$backButtonText = _a.backButtonText,
          backButtonText = _a$backButtonText === void 0 ? 'Back' : _a$backButtonText,
          _a$cancelButtonText = _a.cancelButtonText,
          cancelButtonText = _a$cancelButtonText === void 0 ? 'Cancel' : _a$cancelButtonText,
          hideClose = _a.hideClose,
          _a$closeButtonAriaLab = _a.closeButtonAriaLabel,
          closeButtonAriaLabel = _a$closeButtonAriaLab === void 0 ? 'Close' : _a$closeButtonAriaLab,
          navAriaLabel = _a.navAriaLabel,
          hasNoBodyPadding = _a.hasNoBodyPadding,
          footer = _a.footer,
          appendTo = _a.appendTo,
          isOpen = _a.isOpen,
          titleId = _a.titleId,
          descriptionId = _a.descriptionId,
          rest = __rest(_a, ["width", "height", "title", "description", "onClose", "onSave", "onBack", "onNext", "onGoToStep", "className", "steps", "startAtStep", "nextButtonText", "backButtonText", "cancelButtonText", "hideClose", "closeButtonAriaLabel", "navAriaLabel", "hasNoBodyPadding", "footer", "appendTo", "isOpen", "titleId", "descriptionId"]);

      var currentStep = this.state.currentStep;
      var flattenedSteps = this.getFlattenedSteps();
      var adjustedStep = flattenedSteps.length < currentStep ? flattenedSteps.length : currentStep;
      var activeStep = flattenedSteps[adjustedStep - 1];
      var computedSteps = this.initSteps(steps);
      var firstStep = activeStep === flattenedSteps[0];
      var isValid = activeStep && activeStep.enableNext !== undefined ? activeStep.enableNext : true;

      var nav = function nav(isWizardNavOpen) {
        return React.createElement(WizardNav, {
          isOpen: isWizardNavOpen,
          "aria-label": navAriaLabel
        }, computedSteps.map(function (step, index) {
          if (step.isFinishedStep) {
            // Don't show finished step in the side nav
            return;
          }

          var enabled;
          var navItemStep;

          if (step.steps) {
            var hasActiveChild = false;
            var canJumpToParent = false;
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
              for (var _iterator3 = step.steps[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                var subStep = _step3.value;

                if (activeStep.name === subStep.name) {
                  // one of the children matches
                  hasActiveChild = true;
                }

                if (subStep.canJumpTo) {
                  canJumpToParent = true;
                }
              }
            } catch (err) {
              _didIteratorError3 = true;
              _iteratorError3 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                  _iterator3.return();
                }
              } finally {
                if (_didIteratorError3) {
                  throw _iteratorError3;
                }
              }
            }

            navItemStep = _this2.getFlattenedStepsIndex(flattenedSteps, step.steps[0].name);
            return React.createElement(WizardNavItem, {
              key: index,
              content: step.name,
              isCurrent: hasActiveChild,
              isDisabled: !canJumpToParent,
              step: navItemStep,
              onNavItemClick: _this2.goToStep
            }, React.createElement(WizardNav, {
              returnList: true
            }, step.steps.map(function (childStep, indexChild) {
              if (childStep.isFinishedStep) {
                // Don't show finished step in the side nav
                return;
              }

              navItemStep = _this2.getFlattenedStepsIndex(flattenedSteps, childStep.name);
              enabled = childStep.canJumpTo;
              return React.createElement(WizardNavItem, {
                key: "child_".concat(indexChild),
                content: childStep.name,
                isCurrent: activeStep.name === childStep.name,
                isDisabled: !enabled,
                step: navItemStep,
                onNavItemClick: _this2.goToStep
              });
            })));
          }

          navItemStep = _this2.getFlattenedStepsIndex(flattenedSteps, step.name);
          enabled = step.canJumpTo;
          return React.createElement(WizardNavItem, {
            key: index,
            content: step.name,
            isCurrent: activeStep.name === step.name,
            isDisabled: !enabled,
            step: navItemStep,
            onNavItemClick: _this2.goToStep
          });
        }));
      };

      var context = {
        goToStepById: this.goToStepById,
        goToStepByName: this.goToStepByName,
        onNext: this.onNext,
        onBack: this.onBack,
        onClose: onClose,
        activeStep: activeStep
      };
      var wizard = React.createElement(WizardContextProvider, {
        value: context
      }, React.createElement("div", Object.assign({}, rest, {
        className: css(styles.wizard, activeStep && activeStep.isFinishedStep && 'pf-m-finished', className)
      }, height && {
        style: {
          height: height
        }
      }), title && React.createElement(WizardHeader, {
        titleId: this.titleId,
        descriptionId: this.descriptionId,
        onClose: onClose,
        title: title,
        description: description,
        closeButtonAriaLabel: closeButtonAriaLabel,
        hideClose: hideClose
      }), React.createElement(WizardToggle, {
        isNavOpen: this.state.isNavOpen,
        onNavToggle: function onNavToggle(isNavOpen) {
          return _this2.setState({
            isNavOpen: isNavOpen
          });
        },
        nav: nav,
        steps: steps,
        activeStep: activeStep,
        hasNoBodyPadding: hasNoBodyPadding
      }, footer || React.createElement(WizardFooterInternal, {
        onNext: this.onNext,
        onBack: this.onBack,
        onClose: onClose,
        isValid: isValid,
        firstStep: firstStep,
        activeStep: activeStep,
        nextButtonText: activeStep && activeStep.nextButtonText || nextButtonText,
        backButtonText: backButtonText,
        cancelButtonText: cancelButtonText
      }))));

      if (isOpen !== undefined) {
        return React.createElement(Modal, {
          isOpen: isOpen,
          variant: ModalVariant.large,
          "aria-labelledby": this.titleId,
          "aria-describedby": this.descriptionId,
          showClose: false,
          hasNoBodyWrapper: true
        }, wizard);
      }

      return wizard;
    }
  }]);

  return Wizard;
}(React.Component);
Wizard.currentId = 0;
Wizard.defaultProps = {
  title: '',
  description: '',
  className: '',
  startAtStep: 1,
  nextButtonText: 'Next',
  backButtonText: 'Back',
  cancelButtonText: 'Cancel',
  hideClose: false,
  closeButtonAriaLabel: 'Close',
  navAriaLabel: 'Steps',
  hasNoBodyPadding: false,
  onBack: null,
  onNext: null,
  onGoToStep: null,
  width: null,
  height: null,
  footer: null,
  onClose: function onClose() {
    return undefined;
  },
  appendTo: null,
  isOpen: undefined
};